import { Clock, Images, Frame, Users, PawPrint, Trees } from "lucide-react";
import { Reveal, SectionHeading, GoldButton } from "./shared";
import { BOOKING_URL } from "./content";

const ITEMS = [
    {
        icon: Clock,
        title: "20 minutes, unhurried",
        desc: "A relaxed studio session: time to settle in, change outfits and let genuine smiles happen.",
        span: "lg:col-span-2 bg-wine",
        light: true,
    },
    {
        icon: Trees,
        title: "Two handcrafted sets",
        desc: "Santa's Sleigh and the Lapland Workshop, both included in every session.",
        span: "",
        light: false,
    },
    {
        icon: Images,
        title: "3 edited digital images",
        desc: "Beautifully retouched, high-resolution images to keep and share.",
        span: "",
        light: false,
    },
    {
        icon: Users,
        title: "Up to 5 family members",
        desc: "One £49 booking covers the whole crew, grown-ups and children alike.",
        span: "",
        light: false,
    },
    {
        icon: PawPrint,
        title: "Pets welcome",
        desc: "Furry family members love the sleigh, so bring them along in their festive best.",
        span: "",
        light: false,
    },
    {
        icon: Frame,
        title: "Print & frame upgrades",
        desc: "Turn your favourites into wall art and Christmas gifts with optional add-ons.",
        span: "",
        light: false,
    },
];

export default function Included() {
    return (
        <section id="included" className="relative py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <SectionHeading
                    eyebrow="The Earlybird £49"
                    title="Everything your £49 earlybird includes"
                    sub="The short version is below: dates, times and the full session details all live on the booking page."
                />
                <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-testid="included-grid">
                    {ITEMS.map((item, i) => (
                        <Reveal key={item.title} delay={i * 0.07} className={item.span || ""}>
                            <div
                                className={`h-full rounded-3xl p-7 transition-transform duration-300 hover:-translate-y-1 ${
                                    item.light
                                        ? "bg-wine text-cream"
                                        : "glass-card text-cream"
                                }`}
                            >
                                <item.icon className={`h-8 w-8 ${item.light ? "text-gold-light" : "text-gold"}`} strokeWidth={1.6} />
                                <h3 className="mt-5 font-serif text-xl font-bold sm:text-2xl">{item.title}</h3>
                                <p className={`mt-2 text-sm leading-relaxed ${item.light ? "text-cream/85" : "text-mist"}`}>
                                    {item.desc}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
                <Reveal delay={0.2} className="mt-10 flex justify-center">
                    <GoldButton href={BOOKING_URL} testId="included-cta-button">
                        See dates & book for £49
                    </GoldButton>
                </Reveal>
            </div>
        </section>
    );
}
